import {useLocation} from 'react-router';
import {NavLink as RouterLink, useHistory} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Box, Button, Drawer, Hidden, List, ListItem, makeStyles, Tooltip} from '@material-ui/core';
import {useDispatch, useSelector} from "react-redux";
import * as actions from "../../../store/actions";
import routes from "../../../config/routes";
import UtilService from "../../../helper/service";
import roles from "../../../helper/roles";
import clsx from 'clsx';
import {useStylesTooltip} from "../../../config/theme";
import Config from '../../../config/config';
import {useCallback, useEffect, useState} from "react";
import {getGravatarImage} from "../../../store/actions/auth/auth";
import Icon from '@material-ui/core/Icon';
import listIcon from '@material-ui/icons/Dashboard';
import libraryBooksIcon from '@material-ui/icons/LibraryBooks';
import peopleIcon from '@material-ui/icons/PeopleAlt';
import settingsIcon from '@material-ui/icons/Settings';
import donutIcon from '@material-ui/icons/DonutSmall';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import {
  getCreatorList,
  onSetChecked,
  onSetSearchText,
  onSetSelected,
  onSetUserDropdown,
  updatesearchfilters,
  updateSearchKey,
  updateSearchText,
  updateSearchUsers
} from "../../../store/actions/experience/experience";
import {
  onSetProjectID,
  onSetTempProject,
  updateProjectFolderId
} from "../../../store/actions/creator/creatorExperienceManager";
import {Mixpanel} from "../../../helper/mixpanel";


const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : {};

const dashboardMenu = () => {
  let object = {}
  if (loginUserData && loginUserData.role_access) {
    if (loginUserData.role_access.length) {
      const creator_dashboard = loginUserData.role_access.filter((val: any) => val.access_name === "creator_dashboard");
      if (creator_dashboard.length > 0 && creator_dashboard[0].access_value) {
        object = {
          title: 'Creator Dashboard',
          href: '/creator/dashboard',
          icon: ['/assets/icons/menu-creator-dashboard-active.svg', '/assets/icons/menu-creator-dashboard-inactive.svg'],
          micon: listIcon,
          tooltip: 'Experience Dashboard'
        }
      } else if (UtilService.checkTrialAccess(loginUserData, roles['trial']['dashboard'])) {
        object = {
          title: 'Trial Dashboard',
          href: '/subscriber/creator/dashboard',
          icon: ['/assets/icons/menu-creator-dashboard-active.svg', '/assets/icons/menu-creator-dashboard-inactive.svg'],
          micon: listIcon,
          tooltip: 'Experience Dashboard'
        }
      } else {
        const participant_dashboard = loginUserData.role_access.filter((val: any) => val.access_name === "participant_dashboard");
        if (participant_dashboard.length > 0 && participant_dashboard[0].access_value) {
          object = {
            title: 'Participant Dashboard',
            href: '/participant/dashboard',
            icon: ['/assets/icons/menu-experiences1.svg', '/assets/icons/menu-experiences2.svg'],
            micon: donutIcon,
            tooltip: ''
          }
        }
      }
    }
  }
  return object
}

const AdminMenu = () => {
  let object = {}
  if (loginUserData && loginUserData.role_access) {
    if (loginUserData.role_access.length) {
      const admin_user = loginUserData.role_access.filter((val: any) => val.access_name === "admin_users");
      if (admin_user.length > 0 && admin_user[0].access_value) {
        object = {
          title: 'Admin',
          href: '/admin/user',
          icon: ['/assets/icons/creator3.svg', '/assets/icons/creator1.svg'],
          micon: settingsIcon,
          tooltip: 'Admin'
        }
      }
      else {
        const trial_admin = loginUserData.role_access.filter((val: any) => val.access_name === "trial_admin");
        if (trial_admin.length > 0 && trial_admin[0].access_value) {
          object = {
            title: 'Admin',
            href: '/subscriber/admin/user',
            icon: ['/assets/icons/creator3.svg', '/assets/icons/creator1.svg'],
            micon: settingsIcon,
            tooltip: 'Admin'
          }
        }
      }
    }
  }
  return object
}

const navConfig = [
  {
    href: '/',
    items: [
      dashboardMenu(),
      {
        title: 'Intercom Resource Page',
        href: 'Intercom_Resource_Page',
        icon: ['/assets/icons/BookOpen1.svg'],
        micon: libraryBooksIcon,
        tooltip: 'Knowledge Base'
      },
      {
        title: 'Participant List',
        href: '/participant/lists',
        icon: ['/assets/icons/menu-participant-list.svg', '/assets/icons/menu-participant-list-inactive.svg'],
        micon: peopleIcon,
        tooltip: 'Participant List'
      },
      {
        title: 'Admin Role',
        href: '/admin/role',
        icon: ['/assets/icons/menu-experiences1.svg', '/assets/icons/menu-experiences2.svg'],
        micon: settingsIcon,
        tooltip: ''
      },
      AdminMenu(),
    ]
  },
];

function renderNavItems({ items, ...rest }: any) {
  return (
    <List disablePadding>
      {items.reduce(
        (acc: any, item: any) => reduceChildRoutes({ acc, item, ...rest }),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({
  acc,
  item,
  depth = 0
}: any) {
  const key = item.title + depth;
  const getRoute = routes.find((ele) => ele.access_path.includes(item.href))
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || '{}') : "";

  let data: any = "";
  if (loginUserData) {
    if (Array.isArray(getRoute?.access_name)) {
      getRoute?.access_name.forEach((name: any) => {
        const tempData = loginUserData.role_access.filter((ele: any) => ele.access_name === name)
        if (tempData.length) {
          data = tempData
        }
      })
    } else {
      data = loginUserData.role_access.filter((ele: any) => ele.access_name === getRoute?.access_name)
    }
  }

  if (getRoute && data.length > 0 && data[0].access_value) {
    acc.push(
      <NavItem
        href={item.href}
        icon={item.icon}
        micon={item.micon}
        tooltip={item.tooltip}
        key={key}
        id={key}
        title={''}
      />
    );

  }

  if (item.href === "Intercom_Resource_Page") {
    acc.push(
      <NavItem
        href={item.href}
        icon={item.icon}
        micon={item.micon}
        tooltip={item.tooltip}
        id={'Intercom_Resource_Page'}
        key={key}
        title={'Intercom_Resource_Page'}
      />
    );
  }
  return acc;

}


function NavBar({ openMobile, onMobileClose, }: any) {
  const classes = useStyles();
  const tooltipClasses = useStylesTooltip();
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || '{}') : "";
  const {
    userPreferencesData, userProfileData, googleProfilePicture, gravatarImg
  } = useSelector((state: any) => state.authUser);
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const [uploadedProfilePic, setUploadedProfilePic] = useState('');

  useEffect(() => {
    let updateLoginUserData = loginUserData;
    if (userProfileData && userProfileData.preferences) {
      const profilePicture = userProfileData.preferences.filter((result: any) => result.preference_name === "PROFILEPIC");
      if (profilePicture.length && profilePicture[0]) {
        updateLoginUserData = { ...loginUserData, profile_picture: profilePicture[0].preference_information };
        localStorage.setItem('user_data', JSON.stringify(updateLoginUserData));
      }
    }
    const profilePic = UtilService.getUserProfile(updateLoginUserData.profile_picture, userProfileData, userPreferencesData);
    if (profilePic === '/static/profile.png') {
      if (updateLoginUserData && updateLoginUserData.username && localStorage.getItem('sso_login') === "false") {
        dispatch(getGravatarImage(apolloClient.client, { email: updateLoginUserData.username }))
      }
    } else {
      setUploadedProfilePic(profilePic);
    }
  }, [userPreferencesData, userProfileData]);

  const handleLogout = () => {
    const windowObject: any = window
    if (windowObject?.Intercom) {
      windowObject.Intercom("shutdown")
    }
    dispatch(actions.onLogout());
  };

  const goProfile = () => {
    let url = `/user/profile`;
    const userData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
    if (!!userData) {
      if (UtilService.checkTrialAccess(userData, roles['trial']['profile'])) {
        url = `/subscriber/user/profile`
      }
    }
    history.push(url);
  };

  const getAvatarImage = useCallback(() => {
    if (uploadedProfilePic) {
      return uploadedProfilePic
    } else if (googleProfilePicture) {
      return googleProfilePicture
    } else if (gravatarImg) {
      return gravatarImg;
    }
    return '/static/profile.png';
  }, [uploadedProfilePic, googleProfilePicture, gravatarImg]);

  const content = (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
    >
      <Box p={1} mt={1}>
        <Box
          display="flex"
          justifyContent="center"
        >
          <img
            alt="Logo"
            src={"/static/" + Config.NAVBAR_LOGO}
            style={{ width: 40, height: 40 }}
          />
        </Box>

        {navConfig.map((config, index) => (
          <List key={index} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {renderNavItems({ items: config.items, pathname: location.pathname })}
          </List>
        ))}
        {/* <List style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Button onClick={() => handleOpenIntercom()} aria-label="intercom">
            <img src="/assets/icons/BookOpen1.svg"></img>
          </Button>
        </List> */}
      </Box>

      <Box
        display="flex"
        justifyContent="center"
        alignItems="flex-end"
        flex={1}
      >
        <Box>
          <Box
            display="flex"
            justifyContent="center"
            onClick={() => goProfile()}
          >
            <Tooltip classes={tooltipClasses} title={'Profile & Settings'} placement="right" arrow>
              <div className={classes.avatar}>
                <img
                  alt="{Profile Image}"
                  src={getAvatarImage()}
                  style={{ width: 40, height: 40, borderRadius: 20 }}
                />
              </div>
            </Tooltip>
          </Box>

          <Tooltip classes={tooltipClasses} title={'Sign Out'} placement="right" arrow>
            <Button onClick={() => handleLogout()} aria-label="delete">
              <ExitToAppIcon className={classes.icon} />
            </Button>
          </Tooltip>
        </Box>

      </Box>

    </Box>
  );

  const children1 = <Drawer
    anchor="left"
    classes={{ paper: classes.mobileDrawer }}
    onClose={onMobileClose}
    open={openMobile}
    variant="temporary"
  >
    {content}
  </Drawer>

  const children2 = <Drawer
    anchor="left"
    classes={{ paper: classes.desktopDrawer }}
    open
    variant="persistent"
  >
    {content}
  </Drawer>
  
  return (
    <>
      <Hidden {...{ mdUp: true, children: children1 }} />
      <Hidden {...{ smDown: true, children: children2 }} />
    </>
  );
}

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

export default NavBar;

const handleOpenIntercom = () => {
  Mixpanel.identify(loginUserData.user_id);
  Mixpanel.track('Intercom_Resource_Page');
  Mixpanel.people.set({
    $email: loginUserData.username,
    $first_name: loginUserData.first_name,
    $last_name: loginUserData.last_name,
    $team: loginUserData.department_name,
    $type: loginUserData.role_alias
  });

  window.open(`${Config.COMPANY_URL}/knowledge_center`);
};

function NavItem({ title, href, micon, tooltip, className, ...rest }: any) {

  const classes = useStyles();
  const dispatch = useDispatch();
  const tooltipClasses = useStylesTooltip();
  const location = useLocation();
  const dashboardIcon = href.substring(href.lastIndexOf('/') + 1);

  const handleMenu = () => {
    clearSearch();
    if (href.includes('/creator/dashboard')) {
      // Show all experiences from Reels or Projects
      onShowAllExperiences();
    }
  };

  const clearSearch = () => {
    dispatch(onSetSearchText(""));
    dispatch(onSetChecked([]));
    dispatch(onSetSelected([]));
    dispatch(onSetUserDropdown(false));
    dispatch(updateSearchKey(''));
    dispatch(updateSearchText(''));
    dispatch(updateSearchUsers([]));
    dispatch(updatesearchfilters('clear'));
    dispatch(getCreatorList(null));
    localStorage.removeItem('search_sort_request');
  };

  const onShowAllExperiences = () => {
    dispatch(onSetProjectID(-1));
    dispatch(updateProjectFolderId(-1));
    localStorage.setItem("projectId", String(-1));
    dispatch(onSetTempProject(false));
  };

  return (
    (title == "Intercom_Resource_Page") ?
      <ListItem
        className={clsx(classes.itemLeaf, className)}
        disableGutters
        key={title}
        {...rest}
      >
        <Tooltip key={title} classes={tooltipClasses} title={tooltip} placement="right" arrow>
          <Button
            id={'id_' + href}
            style={{ paddingLeft: 8 }}
            onClick={() => handleOpenIntercom()} aria-label="intercom"
          >
            <Icon component={micon} className={classes.icon} id={'id_' + href}/>
            
          </Button>
        </Tooltip>
      </ListItem>
      :
      <ListItem
        className={clsx(classes.itemLeaf, className)}
        disableGutters
        key={title}
        {...rest}
      >
        <Tooltip key={title} classes={tooltipClasses} title={tooltip} placement="right" arrow>
          <Button
            activeClassName={classes.active}
            component={RouterLink}
            exact
            id={'id_' + href}
            style={dashboardIcon === "dashboard" ? { paddingLeft: 6 } : { paddingLeft: 8 }}
            to={href}
            onClick={handleMenu}
          >

            <Icon component={micon} className={clsx(classes.icon, location.pathname.includes(href) ? classes.iconActive : '')} id={'id_' + href}/>


          </Button>
        </Tooltip>
      </ListItem>
  );
}

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 65,
    background: Config.NAVBAR_BACKGROUND + '!important'
  },
  desktopDrawer: {
    width: 65,
    background: Config.NAVBAR_BACKGROUND + '!important'
  },
  iconActive: {
    color: Config.NAVBAR_ACTIVE,
  },
  icon: {
    alignItems: 'center',
    color: Config.NAVBAR_PRIMARY,
    width: 25,
    height: 25,
    '&:hover': {
      color: Config.NAVBAR_ACTIVE,
    }
  },
  mb2: {
    marginBottom: 8
  },
  itemLeaf: {
    display: 'flex',
    paddingTop: 8,
    paddingBottom: 0
  },
  avatar: {
    border: '1px solid ' + Config.NAVBAR_PRIMARY,
    borderRadius: 27,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 0,
    marginBottom: 32,
    background: Config.NAVBAR_PRIMARY,
    '&:hover': {
      cursor: 'pointer',
    }
  },
  active: {
    color: Config.NAVBAR_PRIMARY,
    '& $title': {
      fontWeight: 'normal',
    },
    '& $icon': {
      color: Config.NAVBAR_ACTIVE
    }
  }
}));
